import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchNoResults = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 9.5C0 4.26173 4.26173 0 9.4996 0C14.7379 0 18.9996 4.26173 18.9996 9.5C18.9996 14.7387 14.7379 19 9.4996 19C4.26173 19 0 14.7387 0 9.5ZM3.13115 5.51166C2.40822 6.66479 1.99023 8.02858 1.99023 9.48999C1.99023 13.6321 5.3481 16.99 9.49023 16.99C13.6324 16.99 16.9902 13.6321 16.9902 9.48999C16.9902 5.34785 13.6324 1.98999 9.49023 1.98999C6.80951 1.98999 4.45727 3.39642 3.13115 5.51166ZM22.0708 23.485L17 18.4142L18.4142 17L23.485 22.0708L22.0708 23.485ZM6.88047 5.60978L5.60982 6.8801L8.22081 9.49041L5.6118 12.1002L6.8821 13.3709L9.49146 10.7607L12.0978 13.3664L13.3684 12.0961L10.7618 9.49006L13.3676 6.88343L12.0973 5.61276L9.49111 8.21974L6.88047 5.60978Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgSearchNoResults);
export { ForwardRef as ReactComponent };
